document.addEventListener('alpine:init', () => {
  Alpine.data('recentlyViewed', (el) => ({
    // ——— State from data-attributes ———
    max:       parseInt(el.dataset.count)       || 8,
    show:      parseInt(el.dataset.show)        || 8,
    current:   el.dataset.productHandle         || '',

    // ——— Internal state ———
    handles:   [],
    loading:   false,
    list:      null,
    canScrollPrev: false,
    canScrollNext: false,
    progress:     0,
    slideWidth:   0,
    visibleCount: 1,

    // NEW: Drawer içinde mi?
    inDrawer: false,

    _initialized: false,

    init() {
      if (this._initialized) return;
      this._initialized = true;

      // NEW: Cart Drawer içinde mi?
      this.inDrawer = !!el.closest('[id^="GA-Cart-Drawer-"]');

      this.list = this.$refs.list;
      this._saveToLocal();
      this._loadHandles();
      this._fetchCards().then(() => {
        this.update();
        if (this.list) {
          let ticking = false;
          this.list.addEventListener('scroll', () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => { this.update(); ticking = false; });
          }, { passive: true });
        }
        window.addEventListener('resize', window.debounce ? window.debounce(() => this.update(), 150) : () => this.update());
      });
    },

    _saveToLocal() {
      if (!this.current) return;
      const key = 'recently-viewed';
      let arr;
      try {
        arr = JSON.parse(localStorage.getItem(key) || '[]');
      } catch (e) {
        arr = [];
      }
      if (!Array.isArray(arr)) arr = [];
      arr = [this.current, ...arr.filter(h => h !== this.current)];
      arr = arr.slice(0, 20);
      localStorage.setItem(key, JSON.stringify(arr));
    },

    _loadHandles() {
      let arr;
      try {
        arr = JSON.parse(localStorage.getItem('recently-viewed') || '[]');
      } catch (e) {
        arr = [];
      }
      if (!Array.isArray(arr)) arr = [];
      this.handles = arr.filter(h => h !== this.current).slice(0, this.max);
    },

    async _fetchCards() {
      if (!this.handles.length) return;
      this.loading = true;
      this.list.innerHTML = '';
      const seen = new Set();
      let count = 0;

      // Template view: search.ga-card-product.liquid (kompakt kart). Bolum
      // kart 02'de tam karti ister (data-card-view → search.ga-card-product-full);
      // cekmecede her zaman kompakt.
      const view       = (!this.inDrawer && el.dataset.cardView) || 'ga-card-product';
      const root       = window.Shopify?.routes?.root       || '/';
      const searchBase = window.Shopify?.routes?.search_url || `${root}search`;

      // Width sınıfı sabitleri
      const MOBILE_2COL_WIDTH = 'etf:[width:calc((100%-theme(spacing.4))/2)]';
      const SM_3COL_WIDTH     = 'etf:sm:[width:calc((100%-theme(spacing.4)*2)/3)]';
      const LG_4COL_WIDTH     = 'etf:lg:[width:calc((100%-theme(spacing.4)*3)/4)]';
      // Drawer için her boyutta 3’lü (ul’de gap-2 kullandığın için spacing.2)
      const DRAWER_3COL_WIDTH = 'etf:[width:calc((100%-theme(spacing.2)*2)/3)]';

      const handlesToFetch = this.handles.slice(0, this.show);
      const results = await Promise.allSettled(
        handlesToFetch.map(handle => {
          const url = `${searchBase}?view=${encodeURIComponent(view)}&type=product&q=${encodeURIComponent('handle:' + handle)}`;
          return fetch(url, { credentials: 'same-origin' })
            .then(res => res.text())
            .then(html => ({ handle, html }));
        })
      );

      for (const result of results) {
        if (result.status !== 'fulfilled') continue;
        const { handle, html } = result.value;
        if (count >= this.show || seen.has(handle)) continue;

        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const li = tmp.querySelector(`li[data-handle="${handle}"]`);
        if (!li) continue;

        seen.add(handle);
        li.classList.add('etf:flex-none', 'etf:snap-start');

        if (this.inDrawer) {
          li.classList.remove(MOBILE_2COL_WIDTH, SM_3COL_WIDTH, LG_4COL_WIDTH);
          li.classList.add(DRAWER_3COL_WIDTH);
        } else {
          li.classList.add(MOBILE_2COL_WIDTH, SM_3COL_WIDTH, LG_4COL_WIDTH);
        }

        this.list.appendChild(li);
        count++;
      }

      if (this.list.children.length) {
        el.classList.remove('etf:hidden');
      }
      this.loading = false;
    },

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.list;
      this.canScrollPrev = scrollLeft > 0;
      this.canScrollNext = scrollLeft + clientWidth < scrollWidth - 1;

      if (scrollWidth > 0) {
        const filled = scrollLeft + clientWidth;
        this.progress = Math.min((filled / scrollWidth) * 100, 100);
        this.slideWidth   = this.list.querySelector('li')?.clientWidth || clientWidth;
        this.visibleCount = Math.floor(clientWidth / this.slideWidth) || 1;
      } else {
        this.progress = 0;
      }
    },

    prev() { this.list.scrollBy({ left: -this.slideWidth * this.visibleCount, behavior: 'smooth' }); },
    next() { this.list.scrollBy({ left:  this.slideWidth * this.visibleCount, behavior: 'smooth' }); }
  }));
});